<div class="container-fluid bg-white layout-wrapper">
  <div class="row">
    <!-- Sidebar -->
    <div class="col-auto p-0">
      <app-side-nav></app-side-nav>
    </div>

    <!-- Main Content -->
    <div class="col px-3 mt-3">
      <!-- Page Heading -->
      <div class="container px-0">
        <div class="row align-items-center mb-4">
          <div class="col-6">
            <h4 class="study-heading">
              <span class="text-muted fw-light">Audit Trail /</span> System
              Audit Trail
            </h4>
          </div>
          <div class="col-6 text-end">
            <button
              class="btn btn-outline-primary me-2"
              (click)="downloadCSV()"
              [disabled]="filteredData.length === 0"
            >
              <i class="bx bx-download"></i> Download CSV
            </button>
          </div>
        </div>
      </div>

      <!-- Filters Section -->
      <div class="container px-0 mb-4">
        <div class="card">
          <div class="card-header bg-light">
            <h5 class="mb-0">Filters</h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <!-- User Filter -->
              <div class="col-12 col-md-6 col-lg-3">
                <label class="form-label fw-bold">User</label>
                <div
                  class="custom-dropdown-container"
                  [class.active]="isUserDropdownOpen"
                >
                  <div
                    class="custom-dropdown-trigger"
                    (click)="toggleUserDropdown()"
                    [class.active]="isUserDropdownOpen"
                  >
                    <span
                      *ngIf="!selectedUserId"
                      class="dropdown-placeholder"
                    >
                      All Users
                    </span>
                    <span *ngIf="selectedUserId">{{ getSelectedUserName() }}</span>
                    <i class="bx bx-chevron-down dropdown-arrow"></i>
                  </div>
                  <div
                    class="custom-dropdown-list"
                    *ngIf="isUserDropdownOpen"
                  >
                    <div class="dropdown-header">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search users..."
                        [(ngModel)]="userSearchText"
                        (input)="filterUsers()"
                      />
                    </div>
                    <div class="dropdown-items">
                      <div
                        class="dropdown-item-custom"
                        (click)="clearUserFilter()"
                      >
                        All Users
                      </div>
                      <div
                        class="dropdown-item-custom"
                        *ngFor="let user of filteredUsers"
                        [class.selected]="selectedUserId === (user.id || user.user_id)"
                        (click)="selectUser(user)"
                      >
                        {{ user.name || user.email }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Action Filter -->
              <div class="col-12 col-md-6 col-lg-3">
                <label class="form-label fw-bold">Action</label>
                <div
                  class="custom-dropdown-container"
                  [class.active]="isActionDropdownOpen"
                >
                  <div
                    class="custom-dropdown-trigger"
                    (click)="toggleActionDropdown()"
                    [class.active]="isActionDropdownOpen"
                  >
                    <span *ngIf="!selectedAction" class="dropdown-placeholder">
                      All Actions
                    </span>
                    <span *ngIf="selectedAction">{{ selectedAction }}</span>
                    <i class="bx bx-chevron-down dropdown-arrow"></i>
                  </div>
                  <div class="custom-dropdown-list" *ngIf="isActionDropdownOpen">
                    <div class="dropdown-items">
                      <div
                        class="dropdown-item-custom"
                        (click)="clearActionFilter()"
                      >
                        All Actions
                      </div>
                      <div
                        class="dropdown-item-custom"
                        *ngFor="let action of availableActions"
                        [class.selected]="selectedAction === action"
                        (click)="selectAction(action)"
                      >
                        {{ action }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Form Filter -->
              <div class="col-12 col-md-6 col-lg-3">
                <label class="form-label fw-bold">Form Name</label>
                <div
                  class="custom-dropdown-container"
                  [class.active]="isFormDropdownOpen"
                >
                  <div
                    class="custom-dropdown-trigger"
                    (click)="toggleFormDropdown()"
                    [class.active]="isFormDropdownOpen"
                  >
                    <span *ngIf="!selectedFormName" class="dropdown-placeholder">
                      All Forms
                    </span>
                    <span *ngIf="selectedFormName">{{ selectedFormName }}</span>
                    <i class="bx bx-chevron-down dropdown-arrow"></i>
                  </div>
                  <div class="custom-dropdown-list" *ngIf="isFormDropdownOpen">
                    <div class="dropdown-header">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search forms..."
                        [(ngModel)]="formSearchText"
                        (input)="filterForms()"
                      />
                    </div>
                    <div class="dropdown-items">
                      <div class="dropdown-item-custom" (click)="clearFormFilter()">
                        All Forms
                      </div>
                      <div
                        class="dropdown-item-custom"
                        *ngFor="let form of filteredForms"
                        [class.selected]="selectedFormName === form"
                        (click)="selectForm(form)"
                      >
                        {{ form }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Date Range -->
              <div class="col-12 col-md-6 col-lg-3">
                <label class="form-label fw-bold">Start Date</label>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="startDate"
                  (change)="applyFilters()"
                />
              </div>

              <div class="col-12 col-md-6 col-lg-3">
                <label class="form-label fw-bold">End Date</label>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="endDate"
                  (change)="applyFilters()"
                />
              </div>

              <!-- Clear Filters Button -->
              <div class="col-12">
                <button
                  class="btn btn-outline-secondary"
                  (click)="clearFilters()"
                >
                  <i class="bx bx-x"></i> Clear All Filters
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Audit Trail Table -->
      <div class="container px-0">
        <div class="card">
          <div class="card-header bg-light d-flex justify-content-between align-items-center">
            <h5 class="mb-0">System Audit Trail Records</h5>
            <span class="text-muted" *ngIf="totalRecords > 0">
              Total: {{ totalRecords }} records
            </span>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive" *ngIf="!loading">
              <table class="table table-hover table-striped mb-0">
                <thead class="table-light">
                  <tr>
                    <th>#</th>
                    <th>Timestamp</th>
                    <th>User ID</th>
                    <th>User Name</th>
                    <th>User Role</th>
                    <th>Action</th>
                    <th>Performed</th>
                    <th>Field Name</th>
                    <th>Old Value</th>
                    <th>New Value</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="paginatedData.length === 0">
                    <td colspan="11" class="text-center text-muted py-4">
                      No system audit trail records found
                    </td>
                  </tr>
                  <tr *ngFor="let record of paginatedData; let i = index">
                    <td>
                      {{ (currentPage - 1) * pageSize + i + 1 }}
                    </td>
                    <td>{{ formatDate(record.timestamp) }}</td>
                    <td>{{ record.user_id || 'N/A' }}</td>
                    <td>{{ record.user_name || 'N/A' }}</td>
                    <td>{{ record.user_role || 'N/A' }}</td>
                    <td>
                      <span
                        class="badge"
                        [ngClass]="getActionBadgeClass(record.action)"
                      >
                        {{ getDisplayAction(record.action) }}
                      </span>
                    </td>
                    <td>{{ record.form_name || 'N/A' }}</td>
                    <td>{{ record.field_name || 'N/A' }}</td>
                    <td>
                      <span
                        class="text-truncate d-inline-block"
                        style="max-width: 150px"
                        [title]="record.old_value || 'N/A'"
                      >
                        {{ record.old_value || 'N/A' }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="text-truncate d-inline-block"
                        style="max-width: 150px"
                        [title]="record.new_value || 'N/A'"
                      >
                        {{ record.new_value || 'N/A' }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="text-truncate d-inline-block"
                        style="max-width: 150px"
                        [title]="record.reason_for_change || 'N/A'"
                      >
                        {{ record.reason_for_change || 'N/A' }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Loading State -->
            <div class="text-center py-5" *ngIf="loading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 text-muted">Loading system audit trail data...</p>
            </div>
          </div>

          <!-- Pagination -->
          <div class="card-footer" *ngIf="!loading && totalPages > 0">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <span class="text-muted">
                  Showing {{ (currentPage - 1) * pageSize + 1 }} to
                  {{ getEndRecordNumber() }} of
                  {{ totalRecords }} records
                </span>
              </div>
              <nav>
                <ul class="pagination mb-0">
                  <li
                    class="page-item"
                    [class.disabled]="currentPage === 1"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      (click)="previousPage()"
                    >
                      Previous
                    </a>
                  </li>
                  <li
                    class="page-item"
                    *ngFor="let page of pageRange"
                    [class.active]="page === currentPage"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      (click)="goToPage(page)"
                    >
                      {{ page }}
                    </a>
                  </li>
                  <li
                    class="page-item"
                    [class.disabled]="currentPage === totalPages"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      (click)="nextPage()"
                    >
                      Next
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

